import script from "./ProfessionalTags.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfessionalTags.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__